import { Component, OnInit, ViewChild } from '@angular/core';
import { Console } from '@angular/core/src/console';
import { NgForm } from '@angular/forms';
import { WebService } from '../../shared/services/web.service';
import { Router } from '@angular/router';
declare var $: any, bootbox: any;

@Component({
  selector: 'app-verifier-register',
  templateUrl: './verifier-register.component.html',
  styleUrls: ['./verifier-register.component.css']
})
export class VerifierRegisterComponent implements OnInit {
  @ViewChild('RegForm') RegForm: NgForm;
  verfierRegister = new VerifierRegister();
  Apiurl: string;
  validation: boolean = false;
  constructor(private webService: WebService, private router: Router) { }

  ngOnInit() {
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
  }

  VerifierRegisterDropdownlist = [{
    id: "Verifier",
    name: 'Verifier'

  },
  {
    id: "Admin",
    name: 'Admin'
  }
  ];
  Register() {
     
    if (!this.RegForm.valid) {
      this.validation = true;
    } else {
      this.Apiurl = "api/Admin/AddAdminRegistrationDetail";
      this.webService.postData(this.Apiurl, this.verfierRegister).subscribe((data: any) => {
        if (data.statusCode == 200) {
          bootbox.alert("Details saved successfully");
           
          this.router.navigate(['/VerifierLogin']);
          //this.verfierRegister = {
          //  Email: null,
          //  Mobileno: null,
          //  Loginname: null,
          //  Rm_Name: null,
          //  Role: null
          //};
        }
        else {
          bootbox.alert(data.message);
        }
      })
    }
  }
 
}

export class VerifierRegister {
  Email: string;
  Mobileno: number;
  Rm_Name: string;
  Loginname: string;
  Role: string;
}

